/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Documents API
 * Documents API
 * OpenAPI spec version: 1.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EmailDocument200,
  EmailDocumentRequestPayload,
  GetAllCustomerDocuments200,
  GetAllCustomerDocumentsParams,
  GetMindBodyCustomerDocuments200,
  GetMindBodyCustomerDocumentsParams,
  GetPresignedDocumentUrl200,
  GetPresignedDocumentUrlParams,
  GetWaiverStatus200,
  GetWaiverStatusParams,
  GetWqDocuments200,
  GetWqDocumentsParams
} from './documents-api.schemas';

import { documentsApiInstance } from '../../common/axios/orvalMutator';
import type { ErrorType, BodyType } from '../../common/axios/orvalMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAllCustomerDocuments = (
  params: GetAllCustomerDocumentsParams,
  options?: SecondParameter<typeof documentsApiInstance>
) => {
  return documentsApiInstance<GetAllCustomerDocuments200>(
    { url: `/staff/customer-documents`, method: 'GET', params },
    options
  );
};

export const getGetAllCustomerDocumentsQueryKey = (
  params?: GetAllCustomerDocumentsParams
) => {
  return [`/staff/customer-documents`, ...(params ? [params] : [])] as const;
};

export const getGetAllCustomerDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetAllCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCustomerDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllCustomerDocumentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllCustomerDocuments>>
  > = () => getAllCustomerDocuments(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCustomerDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllCustomerDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllCustomerDocuments>>
>;
export type GetAllCustomerDocumentsQueryError = ErrorType<unknown>;

export function useGetAllCustomerDocuments<
  TData = Awaited<ReturnType<typeof getAllCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetAllCustomerDocumentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCustomerDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCustomerDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllCustomerDocuments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllCustomerDocuments<
  TData = Awaited<ReturnType<typeof getAllCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetAllCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCustomerDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCustomerDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllCustomerDocuments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllCustomerDocuments<
  TData = Awaited<ReturnType<typeof getAllCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetAllCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCustomerDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllCustomerDocuments<
  TData = Awaited<ReturnType<typeof getAllCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetAllCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllCustomerDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllCustomerDocumentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWqDocuments = (
  params: GetWqDocumentsParams,
  options?: SecondParameter<typeof documentsApiInstance>
) => {
  return documentsApiInstance<GetWqDocuments200>(
    { url: `/staff/wq-documents`, method: 'GET', params },
    options
  );
};

export const getGetWqDocumentsQueryKey = (params?: GetWqDocumentsParams) => {
  return [`/staff/wq-documents`, ...(params ? [params] : [])] as const;
};

export const getGetWqDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWqDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetWqDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWqDocuments>>, TError, TData>
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWqDocumentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWqDocuments>>
  > = () => getWqDocuments(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWqDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWqDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWqDocuments>>
>;
export type GetWqDocumentsQueryError = ErrorType<unknown>;

export function useGetWqDocuments<
  TData = Awaited<ReturnType<typeof getWqDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetWqDocumentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWqDocuments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWqDocuments>>,
          TError,
          Awaited<ReturnType<typeof getWqDocuments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWqDocuments<
  TData = Awaited<ReturnType<typeof getWqDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetWqDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWqDocuments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWqDocuments>>,
          TError,
          Awaited<ReturnType<typeof getWqDocuments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWqDocuments<
  TData = Awaited<ReturnType<typeof getWqDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetWqDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWqDocuments>>, TError, TData>
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetWqDocuments<
  TData = Awaited<ReturnType<typeof getWqDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetWqDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWqDocuments>>, TError, TData>
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWqDocumentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMindBodyCustomerDocuments = (
  params: GetMindBodyCustomerDocumentsParams,
  options?: SecondParameter<typeof documentsApiInstance>
) => {
  return documentsApiInstance<GetMindBodyCustomerDocuments200>(
    { url: `/staff/mindbody-customer-documents`, method: 'GET', params },
    options
  );
};

export const getGetMindBodyCustomerDocumentsQueryKey = (
  params?: GetMindBodyCustomerDocumentsParams
) => {
  return [
    `/staff/mindbody-customer-documents`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetMindBodyCustomerDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetMindBodyCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMindBodyCustomerDocumentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>
  > = () => getMindBodyCustomerDocuments(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMindBodyCustomerDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>
>;
export type GetMindBodyCustomerDocumentsQueryError = ErrorType<unknown>;

export function useGetMindBodyCustomerDocuments<
  TData = Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetMindBodyCustomerDocumentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
          TError,
          Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMindBodyCustomerDocuments<
  TData = Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetMindBodyCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
          TError,
          Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMindBodyCustomerDocuments<
  TData = Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetMindBodyCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMindBodyCustomerDocuments<
  TData = Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
  TError = ErrorType<unknown>
>(
  params: GetMindBodyCustomerDocumentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindBodyCustomerDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMindBodyCustomerDocumentsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getWaiverStatus = (
  params: GetWaiverStatusParams,
  options?: SecondParameter<typeof documentsApiInstance>
) => {
  return documentsApiInstance<GetWaiverStatus200>(
    { url: `/staff/waiver-status`, method: 'GET', params },
    options
  );
};

export const getGetWaiverStatusQueryKey = (params?: GetWaiverStatusParams) => {
  return [`/staff/waiver-status`, ...(params ? [params] : [])] as const;
};

export const getGetWaiverStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getWaiverStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetWaiverStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWaiverStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWaiverStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWaiverStatus>>
  > = () => getWaiverStatus(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWaiverStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWaiverStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWaiverStatus>>
>;
export type GetWaiverStatusQueryError = ErrorType<unknown>;

export function useGetWaiverStatus<
  TData = Awaited<ReturnType<typeof getWaiverStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetWaiverStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWaiverStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWaiverStatus>>,
          TError,
          Awaited<ReturnType<typeof getWaiverStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWaiverStatus<
  TData = Awaited<ReturnType<typeof getWaiverStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetWaiverStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWaiverStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWaiverStatus>>,
          TError,
          Awaited<ReturnType<typeof getWaiverStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWaiverStatus<
  TData = Awaited<ReturnType<typeof getWaiverStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetWaiverStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWaiverStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetWaiverStatus<
  TData = Awaited<ReturnType<typeof getWaiverStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetWaiverStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWaiverStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWaiverStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPresignedDocumentUrl = (
  options?: SecondParameter<typeof documentsApiInstance>
) => {
  return documentsApiInstance<GetPresignedDocumentUrl200>(
    { url: `/staff/presigned-document-url/*`, method: 'GET' },
    options
  );
};

export const getGetPresignedDocumentUrlQueryKey = () => {
  return [`/staff/presigned-document-url/*`] as const;
};

export const getGetPresignedDocumentUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof documentsApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPresignedDocumentUrlQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPresignedDocumentUrl>>
  > = () => getPresignedDocumentUrl(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPresignedDocumentUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPresignedDocumentUrl>>
>;
export type GetPresignedDocumentUrlQueryError = ErrorType<unknown>;

export function useGetPresignedDocumentUrl<
  TData = Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
          TError,
          Awaited<ReturnType<typeof getPresignedDocumentUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPresignedDocumentUrl<
  TData = Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
          TError,
          Awaited<ReturnType<typeof getPresignedDocumentUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPresignedDocumentUrl<
  TData = Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPresignedDocumentUrl<
  TData = Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPresignedDocumentUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPresignedDocumentUrlQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const emailDocument = (
  emailDocumentRequestPayload: BodyType<EmailDocumentRequestPayload>,
  options?: SecondParameter<typeof documentsApiInstance>
) => {
  return documentsApiInstance<EmailDocument200>(
    {
      url: `/staff/document/send-email`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: emailDocumentRequestPayload
    },
    options
  );
};

export const getEmailDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocument>>,
    TError,
    { data: BodyType<EmailDocumentRequestPayload> },
    TContext
  >;
  request?: SecondParameter<typeof documentsApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocument>>,
  TError,
  { data: BodyType<EmailDocumentRequestPayload> },
  TContext
> => {
  const mutationKey = ['emailDocument'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocument>>,
    { data: BodyType<EmailDocumentRequestPayload> }
  > = props => {
    const { data } = props ?? {};

    return emailDocument(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocument>>
>;
export type EmailDocumentMutationBody = BodyType<EmailDocumentRequestPayload>;
export type EmailDocumentMutationError = ErrorType<unknown>;

export const useEmailDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocument>>,
      TError,
      { data: BodyType<EmailDocumentRequestPayload> },
      TContext
    >;
    request?: SecondParameter<typeof documentsApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocument>>,
  TError,
  { data: BodyType<EmailDocumentRequestPayload> },
  TContext
> => {
  const mutationOptions = getEmailDocumentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
